import React from 'react';
import { ConversationCallItem } from '../../../../domain/models/Conversation';

export type CallDirection = 'incoming' | 'outgoing' | 'missed';

export const getCallDirection = (item: ConversationCallItem): CallDirection => {
  if (item.missed) return 'missed';
  return item.direction === 'outbound' ? 'outgoing' : 'incoming';
};

export const CALL_LABELS: Record<CallDirection, string> = {
  incoming: 'Appel entrant',
  outgoing: 'Appel sortant',
  missed: 'Appel manqué',
};

// lucide PhoneIncoming / PhoneOutgoing / PhoneMissed, wrapped like ConciergeBellIcon (lucide is not a web dependency)
const ARROW_PATHS: Record<CallDirection, string[]> = {
  incoming: ['M16 2v6h6', 'm22 2-6 6'],
  outgoing: ['m16 8 6-6', 'M22 8V2h-6'],
  missed: ['m16 2 6 6', 'm22 2-6 6'],
};

const CallDirectionIcon: React.FC<{ direction: CallDirection }> = ({ direction }) => (
  <span aria-hidden="true" className="anticon">
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384" />
      {ARROW_PATHS[direction].map((path) => (
        <path key={path} d={path} />
      ))}
    </svg>
  </span>
);

export default CallDirectionIcon;
